import BaseService from '@/services/base.service';
import {get, HttpResponse} from '@/services/http';

export class HealthService extends BaseService {

	ping(timeout: number): Promise<HttpResponse<unknown>> {
		const url = this.url('ping');
		return get(url, {timeout});
	}

}
